export default __webpack_public_path__ + "static/media/1.83e85b09.gif";